import React, { useContext } from 'react';
import { mixpanelEventTrack } from '../../services/mixpanel';
import BookerContext from '../../context/bookerContext';
import BookerShortContext from '../../context/bookerShortContext';
import FetchService from '../../services/fetchService';
import urlService from '../../services/urlService';
import { ReactComponent as ShareIcon } from '../../assets/img/share.svg';
import destinationIcon from '../../assets/img/destination.png';
import '../../assets/styles/booker-ride-header.sass';

const RideHeader = () => {
  const context = useContext(BookerContext);
  const {
    state: { dropoff, isWebBooker },
  } = context;
  const { ride, rideStatus, changeDestination } = useContext(BookerShortContext);
  const { eta, id, dropoff_line1, dropoff_city, dropoff_state, dropoff_postal_code } = ride || {};
  const destination =
    dropoff?.text ||
    (dropoff_line1 ? `${dropoff_line1}, ${dropoff_city}, ${dropoff_state} ${dropoff_postal_code}` : '');

  const canShare = 'share' in window.navigator;

  const shareRide = async () => {
    mixpanelEventTrack(isWebBooker ? 'shareStatusTappedWebBook' : 'shareStatusTapped');

    if (navigator.share) {
      const url = await FetchService.getWebApiResource(urlService.getShareLink(id))
        .then(async response => {
          const { link } = response || {};
          console.log('link ', link);
          return link;
        })
        .catch(console.error);

      navigator
        .share({
          title: document.title,
          text: 'Share Status',
          url,
        })
        .then(() => console.log('Successful share'))
        .catch(error => console.log('Error sharing:', error));
    }
  };

  if (!(ride && rideStatus === 'enroute')) return <></>;

  return (
    <div className="ride-header">
      <div className="ride-title">Enjoy your ride!</div>
      <div className="ride-eta">
        <div className="eta-label">Your destination</div>
        {/*eta && <div className="eta-value">ETA {eta} Min</div>*/}
      </div>

      <div className="ride-destination">{destination}</div>

      <div className="ride-handler">
        {canShare && (
          <div className="share-ride" onClick={shareRide}>
            <div className="info-btn">
              <ShareIcon />
            </div>
            Share Status
          </div>
        )}
        <div className="change-destination" onClick={changeDestination}>
          <img src={destinationIcon} alt="Change Destination" className="info-btn info-btn-destination" />
          Change destination
        </div>
      </div>
    </div>
  );
};

export default RideHeader;
